import { render, staticRenderFns } from "./BuildMicroPolicies.vue?vue&type=template&id=3a5e6234&scoped=true"
import script from "./BuildMicroPolicies.vue?vue&type=script&lang=js"
export * from "./BuildMicroPolicies.vue?vue&type=script&lang=js"
import style0 from "./BuildMicroPolicies.vue?vue&type=style&index=0&id=3a5e6234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e6234",
  null
  
)

export default component.exports